// date-with-milliseconds.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'dateWithMilliseconds' })
export class DateWithMillisecondsPipe implements PipeTransform {
  transform(value: Date | number | string): string | null {
    if (!value) {
      return null;
    }
    // Convert to a Date object if necessary
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return null;
    }
    // Format the date portion
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    // Format milliseconds
    const milliseconds = date.getMilliseconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }
}
